import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import FormLabel from "../../components/Common/FormLabel";
import FormSelect from "../../components/Common/FormSelect";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import { getClientInformation } from "../../redux/Slices/clientInformationSlice";
import ToastNotification from "../../components/Common/ToastNotification";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import {
  updatePostWorkoutPreferenceThunk,
  clearUpdateMessage,
} from "../../redux/Slices/workoutPreferencePost";
import FormControlTextArea from "../../components/Common/FormControlTextArea";
import { CONSTANTS } from "../../utils/Constant/Constant";
function WorkOutPreferenceForm({ selectedClientId, selectedCoachId, status }) {
  const dispatch = useDispatch();
  const { trans } = useCustomTranslation();
  const { clientData } = useSelector((state) => state.clientInformation);
  const { updateSuccessMessage, updateFailedMessage } = useSelector(
    (state) => state.postWorkoutPreference
  );
  const { Option } = Select;
  const [toastConfig, setToastConfig] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [errors, setErrors] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [formData, setFormData] = useState({
    workoutsPerWeek: "",
    ExperienceLevel: "",
    Equipments: "",
    Location: "",
  });

  const [ClientDataForm, setClientDataForm] = useState(null);
  const [selectedExperienceLevel, setSelectedExperienceLevel] = useState(null);
  const [SelectedEquipment, SetSelectedEquipmentList] = useState(null);
  const [selectedDaysOfWeek, setSelectedDaysOfWeek] = useState(null);
  const [activeVariables, setActiveVariables] = useState(null);
  const [commnet, setComment] = useState("");
  // useEffect(() => {
  //   dispatch(
  //     getClientInformation({
  //       clientId: selectedClientId,
  //       coachId: selectedCoachId,
  //     })
  //   );
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [dispatch]);

  useEffect(() => {
    if (updateSuccessMessage) {
      setToastConfig({
        type: CONSTANTS.TOAST_SUCCESS,
        message: updateSuccessMessage,
        heading: trans("Common.success"),
      });
      dispatch(clearUpdateMessage());
    } else if (updateFailedMessage) {
      setToastConfig({
        type: CONSTANTS.TOAST_ERROR,
        message: updateFailedMessage,
        heading: trans("Common.failed"),
      });
      dispatch(clearUpdateMessage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, updateSuccessMessage, updateFailedMessage]);

  useEffect(() => {
    setClientDataForm({
      clientId: selectedClientId,
      experienceLevel: "",
      equipment: "",
      workoutsPerWeek: "",
      injuryDescription: "",
      clientProvidedInputs: clientData?.clientProvidedInputs,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientData]);

  useEffect(() => {
    const injuryInput = clientData?.clientProvidedInputs?.find(
      (input) => input.questionId === 9
    );
    const initialActiveVariables = {};
    injuryInput?.options?.forEach((option) => {
      initialActiveVariables[option.optionText] = false;
    });

    setActiveVariables(initialActiveVariables);

    const selectedOptionIds = injuryInput?.selectedOptionIds
      .split(",")
      .map((id) => id.trim());
    selectedOptionIds?.forEach((id) => {
      const selectedOption = injuryInput?.options?.find(
        (option) => option.optionId.toString() === id
      );
      if (selectedOption) {
        initialActiveVariables[selectedOption.optionText] = true;
      }
    });

    setActiveVariables(initialActiveVariables);

    const clientComment = ClientDataForm?.clientProvidedInputs?.find(
      (input) => input.questionId === CONSTANTS.NINE
    )?.comment;

    setComment(clientComment);

    const locationInput = clientData?.clientProvidedInputs?.find(
      (input) => input.title === CONSTANTS.TRAINING_LOCATION
    );
    if (locationInput) {
      const selectedOptionIds = locationInput?.selectedOptionIds
        .split(",")
        .map((id) => id.trim());
      const initialSelectedItems = locationInput?.options
        .filter((option) =>
          selectedOptionIds?.includes(option.optionId.toString())
        )
        .map((option) => option.optionText);
      setSelectedItems(initialSelectedItems);
    }

    const experienceInputList = clientData?.clientProvidedInputs?.find(
      (input) => input.title === CONSTANTS.TRAINING_EXPERIENCE
    );

    if (experienceInputList) {
      setSelectedExperienceLevel(experienceInputList?.selectedOptionIds);
    }

    const daysWeekInput = clientData?.clientProvidedInputs?.find(
      (input) => input.title === CONSTANTS.TRAINING_SCHEDULE
    );

    if (daysWeekInput) {
      const selectedOptionIds = daysWeekInput?.selectedOptionIds
        .split(",")
        .map((id) => id.trim());
      const initialSelectedItems = daysWeekInput?.options
        .filter((option) =>
          selectedOptionIds?.includes(option.optionId.toString())
        )
        .map((option) => option.optionText);
      setSelectedDaysOfWeek(initialSelectedItems);
    }

    const ExperienceLevel = clientData?.clientProvidedInputs?.find(
      (input) => input.title === CONSTANTS.TRAINING_EXPERIENCE
    );
    if (ExperienceLevel) {
      const selectedOptionIds = ExperienceLevel?.selectedOptionIds
        .split(",")
        .map((id) => id.trim());
      const initialSelectedItems = ExperienceLevel?.options
        .filter((option) =>
          selectedOptionIds?.includes(option.optionId.toString())
        )
        .map((option) => option.optionText);

      setFormData((prev) => ({
        ...prev,
        ExperienceLevel: initialSelectedItems,
      }));
    }

    const Equipmentform = clientData?.clientProvidedInputs?.find(
      (input) => input.title === CONSTANTS.TRAINING_EQUIPMENT
    );
    if (Equipmentform) {
      const selectedOptionIds = Equipmentform?.selectedOptionIds
        .split(",")
        .map((id) => id.trim());
      const initialSelectedItems = Equipmentform?.options
        .filter((option) =>
          selectedOptionIds?.includes(option.optionId.toString())
        )
        .map((option) => option.optionText);
      setFormData((prev) => ({
        ...prev,
        Equipments: initialSelectedItems,
      }));
      SetSelectedEquipmentList(initialSelectedItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientData]);

  const handleDaysPerWeek = (value) => {
    setErrors({});
    setSelectedDaysOfWeek(value);
    const updatedClientDataForm = JSON.parse(JSON.stringify(ClientDataForm));
    const trainingDaysInput = updatedClientDataForm.clientProvidedInputs.find(
      (input) => input.questionId === CONSTANTS.TEN
    );
    if (trainingDaysInput) {
      const optionIds = trainingDaysInput.options
        .filter((option) => value.includes(option.optionText))
        .map((option) => option.optionId);
      const optionIdsString = optionIds.join(",");
      trainingDaysInput.selectedOptionIds = optionIdsString;
    } else {
    }
    setClientDataForm(updatedClientDataForm);
    setFormData((prev) => ({
      ...prev,
      workoutsPerWeek: value,
    }));
  };

  const handleChange = (value) => {
    setErrors({});
    setSelectedItems(value);
    const updatedClientDataForm = JSON.parse(JSON.stringify(ClientDataForm));
    const trainingLocationInput =
      updatedClientDataForm.clientProvidedInputs.find(
        (input) => input.questionId === CONSTANTS.ELEVEN
      );
    if (trainingLocationInput) {
      const optionIds = trainingLocationInput.options
        .filter((option) => value.includes(option.optionText))
        .map((option) => option.optionId);
      const optionIdsString = optionIds.join(",");
      trainingLocationInput.selectedOptionIds = optionIdsString;
    } else {
    }
    setClientDataForm(updatedClientDataForm);

    setFormData((prev) => ({
      ...prev,
      Location: value,
    }));
  };
  const onChangeInjuryDesc = (newComment) => {
    setComment(newComment);
    setClientDataForm((prevForm) => ({
      ...prevForm,
      injuryDescription: newComment,
    }));
  };
  const handleEquipmentChange = (value) => {
    SetSelectedEquipmentList(value);

    const updatedClientDataForm = JSON.parse(JSON.stringify(ClientDataForm));

    // Find the training location input
    const trainingLocationInput =
      updatedClientDataForm.clientProvidedInputs.find(
        (input) => input.questionId === CONSTANTS.TWELVE
      );

    if (trainingLocationInput) {
      const optionIds = trainingLocationInput.options
        .filter((option) => value.includes(option.optionText))
        .map((option) => option.optionId);
      const optionIdsString = optionIds.join(",");
      trainingLocationInput.selectedOptionIds = optionIdsString;
    } else {
    }

    setClientDataForm(updatedClientDataForm);
  };

  const handleVariableClick = (variable) => {
    setActiveVariables((prevState) => {
      const newActiveVariables = {
        ...prevState,
        [variable]: !prevState[variable],
      };

      const selectedInjuries = Object.keys(newActiveVariables).filter(
        (key) => newActiveVariables[key]
      );

      const updatedClientDataForm = JSON.parse(JSON.stringify(ClientDataForm));

      // Find the training location input
      const trainingLocationInput =
        updatedClientDataForm.clientProvidedInputs.find(
          (input) => input.questionId === CONSTANTS.NINE
        );

      if (trainingLocationInput) {
        const optionIds = trainingLocationInput.options
          .filter((option) => selectedInjuries.includes(option.optionText))
          .map((option) => option.optionId);
        const optionIdsString = optionIds.join(",");
        trainingLocationInput.selectedOptionIds = optionIdsString;
      } else {
      }
      setClientDataForm(updatedClientDataForm);

      return newActiveVariables;
    });
  };

  return (
    <div className="mx-2">
      <Row className="mt-3">
        <Col xs={6} sm={6} md={6} lg={6}>
          <FormLabel label={trans("ClientWorkout.WorkoutPerWeek")} required />

          <Select
            className={
              errors.DayesOfWeek
                ? "client-detail-full-width-invalid "
                : "client-detail-full-width"
            }
            mode="multiple"
            name={trans("ClientWorkout.locations")}
            placeholder="Select items"
            onChange={handleDaysPerWeek}
            value={selectedDaysOfWeek}
            allowClear
            dropdownClassName="custom-dropdown-style"
          >
            {clientData &&
              clientData?.clientProvidedInputs
                .filter((input) => input.questionId === CONSTANTS.TEN)
                .flatMap((input) =>
                  input.options.map((option) => (
                    <Option key={option.optionId} value={option.optionText}>
                      {option.optionText}
                    </Option>
                  ))
                )}
          </Select>
          {errors.DayesOfWeek && (
            <div className="invalid-feedback d-block">{errors.DayesOfWeek}</div>
          )}
        </Col>

        <Col xs={6} sm={6} md={6} lg={6}>
          <FormSelect
            label={trans("ClientWorkout.experienceLevel")}
            name={trans("ClientWorkout.experienceLevel")}
            placeholder="Select Experience Level"
            value={selectedExperienceLevel}
            onChange={(event) => {
              setSelectedExperienceLevel(event.target.value);
              const selectedValue = event.target.value;
              const updatedClientDataForm = JSON.parse(
                JSON.stringify(ClientDataForm)
              );
              const experienceInput =
                updatedClientDataForm.clientProvidedInputs.find(
                  (input) => input.questionId === CONSTANTS.THIRTEEN
                );
              if (experienceInput) {
                experienceInput.selectedOptionIds = selectedValue;
                setClientDataForm(updatedClientDataForm);
              } else {
              }

              const options = ClientDataForm?.clientProvidedInputs
                .filter((input) => input.questionId === CONSTANTS.THIRTEEN) // Filter by questionId
                .flatMap((input) => input.options);
              const selectedOption = options.find(
                (option) =>
                  option.optionId.toString() === selectedValue.toString()
              );

              if (selectedOption) {
                setFormData((prev) => ({
                  ...prev,
                  ExperienceLevel: selectedValue,
                }));
              } else {
              }
            }}
            className={"preference-form"}
            options={clientData?.clientProvidedInputs
              .filter((input) => input.questionId === CONSTANTS.THIRTEEN)
              .flatMap((input) =>
                input.options.map((option) => ({
                  value: option.optionId,
                  label: option.optionText,
                }))
              )}
            labelRequired={true}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col xs={6} sm={6} md={6} lg={6}>
          <FormLabel label={trans("ClientWorkout.locations")} required />
          <div>
            <Select
              className={
                errors.location
                  ? "client-detail-full-width-invalid "
                  : "client-detail-full-width"
              }
              mode="multiple"
              name={trans("ClientWorkout.location")}
              placeholder="Select items"
              onChange={handleChange}
              value={selectedItems}
              allowClear
              dropdownClassName="custom-dropdown-style"
            >
              {clientData &&
                clientData?.clientProvidedInputs
                  .filter((input) => input.questionId === CONSTANTS.ELEVEN)
                  .flatMap((input) =>
                    input.options.map((option) => (
                      <Option key={option.optionId} value={option.optionText}>
                        {option.optionText}
                      </Option>
                    ))
                  )}
            </Select>
            {errors.location && (
              <div className="invalid-feedback d-block">{errors.location}</div>
            )}
          </div>
        </Col>

        <Col xs={6} sm={6} md={6} lg={6}>
          <FormLabel label={trans("ClientWorkout.equipments")} />
          <Select
            className="client-detail-full-width"
            mode="multiple"
            name={"Equipment"}
            placeholder="Select items"
            onChange={handleEquipmentChange}
            value={SelectedEquipment}
            allowClear
            dropdownClassName="custom-dropdown-style"
          >
            {clientData &&
              clientData?.clientProvidedInputs
                .filter((input) => input.title === "Training Equipment")
                .flatMap((input) =>
                  input?.options?.map((option) => (
                    <Option key={option.optionId} value={option.optionText}>
                      {option.optionText}
                    </Option>
                  ))
                )}
          </Select>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col xs={6} sm={6} md={6} lg={6}>
          <FormLabel label={trans("ClientWorkout.injuries")} />
          <br />
          {activeVariables && Object.keys(activeVariables).length > 0 ? (
            Object.keys(activeVariables).map((variable) => (
              <Button
                key={variable}
                variant="outline-light"
                size="sm"
                onClick={() => handleVariableClick(variable)}
                className={`present-variable-button-injury mx-1 mt-1 ${
                  activeVariables[variable] ? "active" : "muted"
                }`}
              >
                {`${variable
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase())}`}
              </Button>
            ))
          ) : (
            <p>Loading...</p>
          )}
        </Col>

        <Col xs={6} sm={6} md={6} lg={6}>
          <FormLabel label={trans("ClientWorkout.injuryDescription")} />
          <FormControlTextArea
            value={commnet}
            onChange={(event) => onChangeInjuryDesc(event.target.value)}
            name={trans("ClientWorkout.injuryDescription")}
            rows={5}
            className="preference-form client-preference-textarea"
          />
        </Col>
      </Row>
      <Button
        className="mt-3 saveButton "
        type="submit"
        disabled={status}
        onClick={() => {
          let isValid = true;
          setErrors({});
          const newErrors = {};
          if (selectedDaysOfWeek.length === 0) {
            newErrors.DayesOfWeek = trans(
              "ClientWorkout.WorkoutPerWeekRequired"
            );
            setErrors(newErrors);
            isValid = false;
            // return;
          }
          if (selectedItems.length === 0) {
            newErrors.location = trans("ClientWorkout.locationRequired");
            setErrors(newErrors);
            isValid = false;
          }
          if (isValid === false) {
            return;
          }
          dispatch(
            updatePostWorkoutPreferenceThunk({
              workoutPreferenceData: ClientDataForm,
            })
          );
        }}
      >
        <i className="bi bi-floppy2-fill"></i> {trans("Common.save")}
      </Button>

      {toastConfig && (
        <ToastNotification
          type={toastConfig.type}
          message={toastConfig.message}
          heading={toastConfig.heading}
        />
      )}
    </div>
  );
}

export default WorkOutPreferenceForm;
